import { GenericService } from "./Generic.service";

export class CategoryService extends GenericService<string>{

    readonly URI: string = 'Categoria'

    constructor(){
        super()
        this.setUri(this.URI);
    }

    public async getAll(){
        return await super.getByResource('', { PageSize: 500 })
    }

    public async getById(id: string){
        return await super.getByResource(`${id}`,  { PageSize: 500 })
    }

}